<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.add_notification") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="row">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                required
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                required
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                required
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                required
              />

              <base-select-input
                col="12"
                :optionsList="All_Users"
                :placeholder="$t('TABLES.Notifications.receiverType')"
                v-model="data.role"
                required
              />

              <base-select-input
                v-if="data.role && data.role.value == 'client'"
                class="col-12"
                :optionsList="clients"
                :placeholder="$t('TITLES.clients')"
                v-model="data.clients"
                required
                multiple
              />
              <base-select-input
                v-if="data.role && data.role.value == 'provider'"
                class="col-12"
                :optionsList="providers"
                :placeholder="$t('PLACEHOLDERS.admins')"
                v-model="data.providers"
                required
                multiple
              />
            </div>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateNotification",

  computed: {
    All_Users() {
      return [
        {
          id: 2,
          name: this.$t("STATUS.all"),
          value: "all",
        },
        {
          id: 1,
          name: this.$t("TITLES.clients"),
          value: "client",
        },
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.providers"),
          value: "provider",
        },
      ];
    },
  },

  data() {
    return {
      isWaitingRequest: false,

      data: {
        clients: null,
        providers: null,
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        role: "",
      },
      clients: [],
      providers: [],
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.titleAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.titleEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.contentAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      } else if (!this.data.contentEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      } else if (!this.data.role) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.role"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.role?.value == "all") {
        REQUEST_DATA.append(`to_type`, "all");
      } else if (this.data.role?.value == "client") {
        // REQUEST_DATA.append(`to_all`, "0");

        if (this.data.clients) {
          const selectedClients = this.data.clients;

          const isAllSelected = selectedClients.some(
            (client) => client.value === "all"
          );

          if (isAllSelected) {
            // this.clients.forEach((client) => {
            //   if (client.value !== "all") {
            //     REQUEST_DATA.append(`users[]`, client.id);
            //   }
            // });
            REQUEST_DATA.append(`to_type`, "allClients");
          } else {
            selectedClients.forEach((element) => {
              REQUEST_DATA.append(`users[]`, element.id);
            });
          }
        }
      } else if (this.data.role?.value == "provider") {
        // REQUEST_DATA.append(`to_all`, "0");

        if (this.data.providers) {
          const selectedProviders = this.data.providers;

          const isAllSelected = selectedProviders.some(
            (provider) => provider.value === "all"
          );

          if (isAllSelected) {
            // this.providers.forEach((provider) => {
            //   if (provider.value !== "all") {
            //     REQUEST_DATA.append(`ids[]`, provider.id);
            //   }
            // });
            REQUEST_DATA.append(`to_type`, "allProviders");
          } else {
            selectedProviders.forEach((element) => {
              console.log(element);
              REQUEST_DATA.append(`users[]`, element.id);
            });
          }
        }
      }

      REQUEST_DATA.append("title[ar]", this.data.titleAr);
      REQUEST_DATA.append("title[en]", this.data.titleEn);
      REQUEST_DATA.append("body[ar]", this.data.contentAr);
      REQUEST_DATA.append("body[en]", this.data.contentEn);

      try {
        await this.$axios({
          method: "POST",
          url: `notification/store`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.sentSuccessfully"));
        this.$router.push({ path: "/all-notifications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    async getClients() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "clients?isActive=1",
          params: {
            ignorePermissionCheck: 1,
          },
        });
        console.log("clients", res);

        this.loading = false;
        this.clients = [
          {
            value: "all",
            name: this.$t("STATUS.all"),
          },
          ...res.data.data?.data,
        ];
        // this.clients = res.data.data?.data.map((user) => user.user);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    async getProviders() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "providers?isActive=1",
          params: {
            ignorePermissionCheck: 1,
          },
        });
        this.loading = false;
        this.providers = [
          {
            value: "all",
            name: this.$t("STATUS.all"),
          },
          ...res.data.data?.data,
        ];
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getClients();
    this.getProviders();
  },
};
</script>
